module.exports = __webpack_public_path__ + "static/media/view med history.39c0e0cb.svg";